export default __webpack_public_path__ + "static/topic18-e0cdb690a7e89b836d2664f0a73a8283.png";